
import request from '@/utils/request'

export function getListAttributeCategoryApi(query) {
  return request({
    url: '/config-service/v1/attribute-category',
    method: 'get',
    params: query
  })
}

export function addAttributeCategoryApi(query) {
  return request({
    url: '/config-service/v1/attribute-category',
    method: 'post',
    data: query
  })
}

export function updateAttributeCategoryApi(query) {
  return request({
    url: `/config-service/v1/attribute-category/${query.id}`,
    method: 'put',
    data: query
  })
}

export function deleteAttributeCategoryApi(query) {
  return request({
    url: '/config-service/v1/attribute-category',
    method: 'delete',
    data: query
  })
}
